import router from './router'
import {ElMessage} from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import useUserStore from '@/store/modules/user'

NProgress.configure({showSpinner: false});
const whitePageList = ['/login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  document.title = to.meta?.documentTitle || '财略人才端'
  if (whitePageList.includes(to.path)) { // 白名单页面，直接打开
    return next()
  }
  if (!useUserStore().token) { // 无token，直接去登录页
    await useUserStore().logOut()
    next({ path: '/login', query: { redirect: to.fullPath } }) // 否则全部重定向到登录页
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})
